import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import {base_urls} from '../../../config/base_urls';
import {Event} from '../../../dto/user-location/event';

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss']
})
export class EventListComponent implements OnInit {
    eventList = new Event();
    filters = {
        userId: null,
        date: null,
        imei: null,
    };

    constructor(
        private route: ActivatedRoute,
        private service: BaseService,
        private auth: AuthService
    ) { }

  ngOnInit() {
      this.route.queryParams.subscribe(params => {
          this.service.getEventList(params, base_urls.p_base).subscribe(eventList => {
              this.eventList = eventList;
              if (this.eventList.points) {
                  this.eventList.points = this.eventList.points.map(item => ({
                      ...item,
                      formattedTime: this.formatTime(item.dateTime)
                  }));
              }
          });
      });
  }

    formatTime(time: string): string {
        const [hours, minutes, seconds] = time.split(':').map(Number);

        const ampm = hours >= 12 ? 'PM' : 'AM';
        const h = hours % 12 || 12;

        const hh = h.toString().padStart(2, '0');
        const mm = minutes.toString().padStart(2, '0');
        const ss = seconds.toString().padStart(2, '0');

        return `${hh}:${mm}:${ss} ${ampm}`;
    }
}
